import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProdutoModalidade } from '../../../models/produto-modalidade.model';
import { ProdutoModalidadeService } from '../../../services/produto-modalidade.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-produto-modalidade-list',
  templateUrl: './produto-modalidade-list.component.html',
  styleUrls: ['./produto-modalidade-list.component.scss'],
})
export class ProdutoModalidadeListComponent
  extends BaseListComponent<ProdutoModalidade>
  implements OnInit, OnDestroy
{
  modalidadeList: ProdutoModalidade[];

  constructor(
    private myService: ProdutoModalidadeService,
    public activatedRoute: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.modalidadeList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/pre-projeto/admin/produto-modalidade/adicionar'];
  }

  editar(id: number) {
    return ['/pre-projeto/admin/produto-modalidade/', id];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
